import _ from 'lodash'

import getErrorMessageByCode from './get-error-message-by-code'

// Convert Error Response to Error Object
//
// Return: object
// - generalError: object
//   - code: number. Error code
//   - message: string. Formatted error message
// - validationError: object
//   - data: object. Same as returned validation error data object from API
// - batchActionErrors: array of object
//   - actionParams: object. The action params in request payload
//   - actionType: string. The action type in request payload
//   - code: number. Error code
//   - index: number. The index of action in request payload
//   - message: string. Formatted error message
// - customErrors: array of object
//   - code: number. Error code
//   - id: string. ID of error object
//   - message: string. Formatted error message
//   - type: string. Error object type, e.g. Cart / CartLine / CartShipment / CouponToken / Order refund request / return request
// - actions: array of object
//   - code: string. Action code
//   - params: object. Params of action
//
export default function convertResponseToErrorObject(res, options={}){
  // Get options
  const customDefaultMessage = _.get(options, 'customDefaultMessage', undefined)
  const useResponseMessage = _.get(options, 'useResponseMessage', false)

  // Handle General Error
  let generalError = {
    code: res.code,
    message: getErrorMessageByCode(res.code, customDefaultMessage)
  }

  // Replace generalError.message with Response Message if requested
  // e.g. for v1 and old v2 endpoint
  if(useResponseMessage){
    const generalObject = _.find(_.get(res, 'errors', []), { type: 'general' })
    if(!_.isEmpty(generalObject)){
      generalError.message = generalObject.message
    }
  }

  // Handle Validation Error
  let validationError = {}
  const validationFailedObject = _.find(_.get(res, 'errors', []), { type: 'validation_failed' })
  if(!_.isEmpty(validationFailedObject)) {
    validationError = {
      data: _.get(validationFailedObject, 'data', {}),
      message: _.get(validationFailedObject, 'message', '')
    }
  }

  // Handle Batch Action Errors. For all updateCart API call.
  let batchActionErrors = []
  _.forEach(res.batchActionErrors, (errorObj, index) => {
    batchActionErrors.push({
      actionParams: _.get(errorObj, 'source.actionParams', {}),
      actionType: _.get(errorObj, 'source.actionType', ''),
      code: errorObj.errorCode,
      index: index,
      message: getErrorMessageByCode(errorObj.errorCode, customDefaultMessage),
      originalMessage: _.get(errorObj, 'message', ''),
    })
  })

  // Handle Checkout Error. For API endpoint `carts/${cartId}/checkout`
  let customErrors = []
  _.forEach(res.errors, (errorObj) => {
    if(errorObj.errorCode){
      customErrors.push({
        code: errorObj.errorCode,
        id: _.get(errorObj, 'source.id', ''),
        message: getErrorMessageByCode(errorObj.errorCode, customDefaultMessage),
        type: _.get(errorObj, 'source.type', '')
      })
    }
  })

  return {
    generalError,
    validationError,
    batchActionErrors,
    customErrors,
    actions: _.get(res, 'actions'),
  }
}


/* ==== Sample Response from API ==== */

// == General Error ==
// {
//   "status": "error",
//   "code": 20001,
//   "errors": [
//     {
//       "message": "invalid state change.",
//       "type": "general"
//     }
//   ]
// }

// == Validation Error ==
// {
//   "status": "error",
//   "code": 422,
//   "errors": [
//     {
//       "message": "Unprocessable Entity",
//       "type": "general"
//     },
//     {
//       "message": "Phone Improbable Phone",
//       "type": "validation_failed",
//       "data": {
//         "delivery_address": {
//           "errors": {
//             "phone": {
//               "message": [
//                 "Improbable Phone"
//               ],
//               "full_message": [
//                 "Phone Improbable Phone"
//               ]
//             }
//           }
//         }
//       }
//     }
//   ]
// }

// == Batch Action Errors ==
// {
//   "cache_checksum": {},
//   "data": {},
//   "batch_action_errors": {
//     "0": {
//       "source": {
//         "action_type": "update_cart_cart_line",
//         "action_params": {
//           "sku_id": 21338,
//           "quantity_mode": "fixed",
//           "quantity": 1
//         }
//       },
//       "error_code": 20300,
//       "message": "Unsupported cart update action_type."
//     },
//     "1": {
//       "source": {
//         "action_type": "update_cart_shipment",
//         "action_params": {
//           "sku_id": 52481,
//           "quantity_mode": "fixed",
//           "quantity": 3
//         }
//       },
//       "error_code": 20601,
//       "message": "Invalid Cart Shipment ID."
//     }
//   }
// }

// == Custom Errors ==
// {
//   "status": "error",
//   "code": 422,
//   "errors": [
//     {
//       "message": "commerce channel not supported guest checkout.",
//       "type": "general"
//     },
//     {
//       "error_code": 20706,
//       "type": "cannot_create_order",
//       "source": {
//         "type": "Cart",
//         "id": "d2604d7c-d92c-4a24-88de-880b37f0b369"
//       },
//       "message": "commerce channel not supported guest checkout."
//     }
//   ]
// }
